import { ClipboardCheck } from "lucide-react";
import { ManualeLayout, Scheda, P, Steps, Bullets, Callout, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#7c3aed";
const SEZIONI = [
  { id: "intro", titolo: "A cosa serve" },
  { id: "formazione", titolo: "Formazione IVASS" },
  { id: "scadenze", titolo: "Scadenzario adempimenti" },
  { id: "faq", titolo: "FAQ" },
];

export default function ManualeCompliance() {
  return (
    <ManualeLayout titolo="Compliance Agenzia" sottotitolo="Aggiornamento professionale IVASS e scadenzario adempimenti" icona={ClipboardCheck} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n="1" titolo="A cosa serve" accent={A}>
        <P>Tiene sotto controllo due obblighi: l'<b>aggiornamento professionale IVASS</b> (ore di formazione per intermediario) e lo <b>scadenzario</b> degli adempimenti dell'agenzia.</P>
      </Scheda>

      <Scheda id="formazione" n="2" titolo="Formazione IVASS" accent={A}>
        <P>La tab <b>Formazione IVASS</b> mostra, per ogni persona attiva, le <b>ore svolte rispetto all'obbligo annuo</b> con barra di avanzamento e indicazione “Obbligo assolto” o “Mancano X ore”.</P>
        <Steps items={[
          "Seleziona l'Anno in alto.",
          "'Nuovo corso': scegli persona, titolo, ente formatore, ore, data e modalità (aula / e-learning / webinar).",
          "Allega l'attestato (PDF o immagine) direttamente sulla riga del corso.",
        ]} />
        <Callout tipo="info">Il conteggio ore e il deficit si aggiornano automaticamente man mano che registri i corsi.</Callout>
      </Scheda>

      <Scheda id="scadenze" n="3" titolo="Scadenzario adempimenti" accent={A}>
        <P>La tab <b>Scadenze</b> elenca gli adempimenti con data, ricorrenza e responsabile.</P>
        <Bullets items={[
          "'Nuova scadenza': titolo, data, ricorrenza (una tantum / settimanale / mensile / trimestrale / annuale), responsabile e note.",
          "Spunta la casella per segnare una scadenza come completata (resta tracciata).",
        ]} />
      </Scheda>

      <Scheda id="faq" n="4" titolo="FAQ" accent={A}>
        <FAQ items={[
          { q: "Da dove arrivano i nomi delle persone?", a: "Dall'anagrafica di Gestione del Personale: aggiungi lì i collaboratori e compariranno qui." },
          { q: "L'obbligo ore è personalizzabile?", a: "L'obbligo è calcolato in base al ruolo della persona; aggiorna il ruolo nella scheda personale se necessario." },
          { q: "Posso conservare gli attestati?", a: "Sì, ogni corso può avere l'attestato allegato, sempre scaricabile." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
